export default __webpack_public_path__ + "static/media/orangeshoe.c57466c8.jpg";